export const CYCLE_RECOMMENDATION_TIMEOUT_MS = 3000;
export const CYCLE_RECOMMENDATION_URL = '/_api/premium-package-pickers-api/get-cycle-recommendation';
export const getCycleRecommendationQueryFn = async props => {
  const {
    httpClient,
    request
  } = props;
  const response = await httpClient.post(CYCLE_RECOMMENDATION_URL, request, {
    timeout: CYCLE_RECOMMENDATION_TIMEOUT_MS
  });
  return response.data;
};
//# sourceMappingURL=get-cycle-recommendation.query.js.map